import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Card, Button, PageHeader, Row, Col } from 'antd'
import Filters, { FilterItem, Types } from '../../components/Filters'
import QuestionList from '../../components/QuestionList'
import { QuestionForm } from '../../components/Forms'
import { QuestionProvider, QuestionConsumer } from '../../context/QuestionContext'
import { ShelterProvider, ShelterConsumer } from '../../context/ShelterContext'
import { QuestionGroupProvider, QuestionGroupConsumer } from '../../context/QuestionGroupContext'
import { LanguageConsumer, LanguageProvider } from '../../context/LanguageContext'

export default class Question extends Component {
   ref:any

  private questionDispatchOptions = {
    search: {
      group: {
        with: true
      },
      specie: {
        with: true
      },
      organization_question_answers: {
        with: {
          _count: true
        }
      }
    },
    options: {
      sort: ['group.name', 'position']
    }
  } as const

  renderAdd = () => {
    const { permissions }: any = this.props
    if (!permissions.create) return null

    return (
      <Link to="question/add">
        <Button type="primary" shape="round">
          Add
        </Button>
      </Link>
    )
  }

  componentDidMount(): void {
    this.ref =  React.createRef();
  }
  render() {
    const { permissions, history, match: { params: { questionUuid } } }: any = this.props

    return (
      <QuestionProvider>
        <QuestionGroupProvider>
          <LanguageProvider>
            <ShelterProvider>
              <QuestionConsumer>
                {(questionContext) => (
                  <QuestionGroupConsumer>
                    {(questionGroupContext) => (
                      <ShelterConsumer>
                        {({ fetching: fetchingShelters, shelters, requestShelterList }) => (
                          <LanguageConsumer>
                            {(languageContext) => {
                              const groupsToFilter = !questionGroupContext.questionGroups ? [] : questionGroupContext.questionGroups.map(group => {
                                return {
                                  value: group.id,
                                  text: group.name
                                }
                              })

                              // Create or edit an entity
                              if (questionUuid) {
                                return (
                                  <Card>
                                    <PageHeader title={questionUuid === 'add' ? 'New Question' : 'Edit Question'} onBack={() => history.replace('/organization/question')}>
                                      <QuestionForm
                                        uuid={questionUuid && questionUuid !== 'add' ? questionUuid : undefined}

                                        permissions={permissions}
                                        history={history}

                                        questionContext={questionContext}
                                        languageContext={languageContext}
                                        questionGroupContext={questionGroupContext}
                                      />
                                    </PageHeader>
                                  </Card>
                                )
                              }

                              return (
                                <>
                                {console.log(questionContext)}
                                  <Card title="Filters" style={{marginBottom: 25}}>
                                    <Filters ref={this.ref} size="medium" loading={questionContext.fetching} history={history} defaultSubmitOptions={this.questionDispatchOptions} submitDispatch={questionContext.requestQuestionList} dispatches={[questionGroupContext.requestQuestionGroupList, requestShelterList]}>
                                      {({ values, handleFilterChange }: any) => (
                                        <Row gutter={9} style={{width: '100%'}}>
                                          <Col xs={24} md={8}>
                                            <FilterItem
                                              name="group_id"
                                              loading={!!questionGroupContext.fetching}
                                              type={Types.SELECT}
                                              placeholder="Filter by Group"
                                              data={groupsToFilter as any || []}
                                              value={values['group_id']}
                                              size="medium"
                                              options={{
                                                select: {
                                                  allowClear: true,
                                                  showSearch: true
                                                }
                                              }}
                                              onChange={handleFilterChange}
                                            />
                                          </Col>

                                          <Col xs={24} md={8}>
                                            <FilterItem
                                              name="uuid"
                                              type={Types.INPUT}
                                              placeholder="Filter by UUID"
                                              value={values['uuid']}
                                              size="medium"
                                              options={{
                                                input: {
                                                  allowClear: true
                                                }
                                              }}
                                              onChange={handleFilterChange}
                                            />
                                          </Col>

                                          <Col xs={24} md={8}>
                                            <FilterItem
                                              name="ask.ilike"
                                              type={Types.INPUT}
                                              placeholder="Filter by question"
                                              value={values['ask.ilike']}
                                              size="medium"
                                              options={{
                                                input: {
                                                  allowClear: true
                                                }
                                              }}
                                              onChange={handleFilterChange}
                                            />
                                          </Col>
                                        </Row>
                                      )}
                                    </Filters>
                                  </Card>
                                  <Card title="List of Questions" extra={this.renderAdd()}>
                                    <QuestionList
                                      loading={questionContext.fetching}
                                      permissions={permissions} 
                                      history={history}
                                      questions={questionContext.questions}
                                      pagination={questionContext.pagination}
                                      defaultSubmitOptions={questionContext.filters}
                                      loadQuestions={questionContext.requestQuestionList}
                                    />
                                  </Card>
                                </>
                              )
                            }}
                          </LanguageConsumer>
                        )}
                      </ShelterConsumer>
                    )}
                  </QuestionGroupConsumer>
                )}
              </QuestionConsumer>
            </ShelterProvider>
          </LanguageProvider>
        </QuestionGroupProvider>
      </QuestionProvider>
    )
  }
}
